<button mat-stroked-button type="button" color="accent" (click)="startTour()">
    <mat-icon>help_outline</mat-icon>
    {{ 'shared.productTour.startBtn' | translate }}
</button>
